import { render, staticRenderFns } from "./biaxChart.vue?vue&type=template&id=a150b342"
import script from "./biaxChart.vue?vue&type=script&lang=js"
export * from "./biaxChart.vue?vue&type=script&lang=js"
import style0 from "./biaxChart.vue?vue&type=style&index=0&id=a150b342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports